





























































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import Uploader from '../components/NewUploader.vue';
import Uploader1 from '../components/NewUploader1.vue';
import { Toast } from 'vant';
import clounbtn from '../components/CloundbtnInfo.vue';
import { FileType } from '@/common/ts/enum';
import { isWeiXin } from '@/common/ts/common';
import { saveinfo, checkInfo, checkUser } from '../api';
import qs from 'qs';

Vue.use(Toast);

@Component({
  components: {
    Uploader,
    Uploader1,
    clounbtn,
  },
})
export default class Rule extends Vue {
  unionid: string | null = '';
  name: string = '';
  url: string = '';
  inway: any = '';
  activeIndex = 1;
  imgStr: any = [];
  videoStr: any = [];
  cover: any[] = [];
  cover2: any[] = [];
  cover1: any[] = [];
  covervideo: any[] = [];
  isexit: any = '';
  FileType = FileType;
  urlsub: any = require('../assets/info/infobtn.png');
  tabs = [
    { code: 1, text: '图片' },
    { code: 2, text: '视频' },
  ];

  mounted() {
    this.unionid = window.localStorage.getItem('unionid') + '';
    this.isexit = this.$route.query.isexit;
    this.inway = this.$route.query.type;
    if (!this.inway) {
      Toast('请选择你加入的阶段');
      this.$router.push('toupload');
    } else {
      this.inway = parseInt(this.inway);
      if (this.inway > 3 || this.inway < 1) {
        Toast('请选择你加入的阶段');
        this.$router.push('toupload');
      }
    }
    if (this.isexit && this.isexit === '1') {
      checkInfo(this.unionid, this.inway).then((res: any) => {
        if (res.code === 200) {
          this.name = res.data.name;
          this.url = res.data.url;
          this.activeIndex = parseInt(res.data.showtype);
          this.imgStr = res.data.cover.split('|');
          this.videoStr = res.data.videoStr.split('|');
          this.url = res.data.url;
          if (res.data.inway === '1' || res.data.inway === '3') {
            this.imgStr.forEach((item: any) => {
              this.cover2.push({
                cover: item,
                path: item,
                type: FileType.Image,
              });
            });
            this.videoStr.forEach((item: any) => {
              this.covervideo.push({
                cover: require('../assets/videocover.png'),
                path: item,
                type: FileType.Video,
              });
            });
          } else if (res.data.inway === '2') {
            if (this.activeIndex === 1) {
              this.imgStr.forEach((item: any) => {
                this.cover.push({
                  cover: item,
                  path: item,
                  type: FileType.Image,
                });
              });
              this.videoStr.forEach((item: any) => {
                this.covervideo.push({
                  cover: require('../assets/videocover.png'),
                  path: item,
                  type: FileType.Video,
                });
              });
            } else if (this.activeIndex === 2) {
              this.imgStr.forEach((item: any) => {
                this.cover1.push({
                  cover: item,
                  path: item,
                  type: FileType.Image,
                });
              });
              this.videoStr.forEach((item: any) => {
                this.covervideo.push({
                  cover: require('../assets/videocover.png'),
                  path: item,
                  type: FileType.Video,
                });
              });
            }
          }
        } else {
          if (res.code !== 400) {
            Toast(res.msg);
          }
        }
      });
    } else {
      checkUser(this.unionid + '').then((res: any) => {
        if (res.code !== 200) {
          Toast('请先注册再上传作品');
          return false;
          // this.$router.push('ininfo');
        }
      });
      checkInfo(this.unionid, this.inway).then((res: any) => {
        if (res.code === 200) {
          if (res.data) {
            this.$router.push('uploadsucc?inway=' + this.inway);
          }
        } else {
          if (res.code !== 400) {
            Toast(res.msg);
          }
        }
      });
    }
  }
  goback() {
    this.$router.push('index');
  }
  changetabs(inx: number) {
    console.log('activinx', inx);
    this.name = '';
    this.url = '';
    this.imgStr = [];
    this.videoStr = [];
    this.cover = [];
    this.cover1 = [];
    this.cover2 = [];
    this.covervideo = [];
    this.activeIndex = inx;
  }
  addInfoTo(dataInfo: any) {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    //todo上传信息
    saveinfo(dataInfo).then((res: any) => {
      if (res.code === 200) {
        this.$router.push('uploadsucc?inway=' + this.inway);
      } else {
        Toast(res.msg);
      }
    });
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async submitBtn() {
    if (this.inway === 2) {
      if (this.activeIndex === 1) {
        if (this.name.length > 30) {
          Toast('限30个字以内');
          return false;
        } else if (!this.name) {
          Toast('请填写作品名称');
          return false;
        } else if (!this.url) {
          Toast('请填写作品链接');
          return false;
        }
      } else if (this.activeIndex === 2) {
        //三期的模块都可以穿视频作品
        if (this.name.length > 30) {
          Toast('限30个字以内');
          return false;
        } else if (!this.name) {
          Toast('请填写作品名称');
          return false;
        } else if (!this.url) {
          Toast('请填写作品链接');
          return false;
        }
      }
    } else {
      //三期的模块都可以穿视频作品
      if (this.name.length > 30) {
        Toast('限30个字以内');
        return false;
      } else if (!this.name) {
        Toast('请填写作品名称');
        return false;
      } else if (!this.url) {
        Toast('请填写作品链接');
        return false;
      }
    }
    if (this.inway === 1 || this.inway === 3) {
      //只有视频作品，封面图图片上传
      this.imgStr = (await (this.$refs
        .uploadImg13 as Uploader).uploadToOss()) as string[];
      if (!this.imgStr) {
        Toast('请上传一张视频封面图');
        return false;
      }
    } else if (this.inway === 2) {
      //课可以选择的图片上传
      if (this.activeIndex === 1) {
        //选择图片作品
        this.imgStr = (await (this.$refs
          .uploadImg as Uploader).uploadToOss()) as string[];
        if (!this.imgStr || this.imgStr.length < 5) {
          Toast('请上传至少五张图片');
          return false;
        }
        if (this.imgStr.length > 9) {
          Toast('最多只能上传9张图片');
          return false;
        }
      } else if (this.activeIndex === 2) {
        //选择视频作品
        this.imgStr = (await (this.$refs
          .uploadImg2 as Uploader).uploadToOss()) as string[];
        if (!this.imgStr) {
          Toast('请上传一张视频封面图');
          return false;
        }
      }
    }
    if (this.inway === 1 || this.inway === 3) {
      //只有视频作品，视频作品上传
      this.videoStr = (await (this.$refs
        .uploadvedio13 as Uploader).uploadToOss()) as string[];
    } else if (this.inway === 2) {
      if (this.activeIndex === 2) {
        //选择视频作品
        this.videoStr = (await (this.$refs
          .uploadvedio2 as Uploader).uploadToOss()) as string[];
      }
    }
    if (!this.videoStr) {
      Toast('请上传作品视频');
      return false;
    }
    // this.uploadImg()  需要上传图片并获取图片或者视频地址

    const dataInfo = {
      name: this.name,
      url: this.url,
      imgStr: this.imgStr.join('|'),
      videoStr: this.videoStr.join('|'),
      unionid: this.unionid,
      showtype: this.inway === 2 ? this.activeIndex : 2, //如果是视频类 那就不能选择固定类型为视频类 2  如果为可选途径那就根据选择类型来
      inway: this.inway,
    };
    this.addInfoTo(dataInfo);
  }
}
